import type { ReactNode } from 'react';

type PageHeaderProps = {
  title?: ReactNode;
  actions?: ReactNode;
};

export function PageHeader({ title, actions }: PageHeaderProps) {
  if (!title) return null;

  return (
    <header className="lms-page-header">
      <div className="lms-page-header-inner">
        <div className="lms-page-header-title">{title}</div>
        {actions && <div className="lms-page-header-actions">{actions}</div>}
      </div>
    </header>
  );
}
